import React, { useState, useEffect } from 'react';
import { Spin, Button, Input, Form, Select, DatePicker, Modal, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { Navigate, Link } from "react-router-dom";
// import { Editor } from '@tinymce/tinymce-react';
// import SideCalendar from '../../side-calendar/SideCalendar';
// import NoticeBoard from '../NoticeBoard';
import { useSelector, useDispatch } from 'react-redux';
// import axios from 'axios';
// import uuid from 'react-uuid';
import NoticeService from '../../../services/NoticeService';
import {
   update_notice_data
} from '../../../actions';
import Utils from '../../../misc/Utils';
import Enums from '../../../misc/Enums';
// import NoticeBoardList from '../NoticeBoardList';
// import { faLeftRight } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import NoticeBoardSlide from '../../../components/notice-board/NoticeBoardSlide';
import ResponsiveBreadcrumb from '../../breadcrumb/ResponsiveBreadcrumb';
import '../NoticeBoard.css';

function EditNotice(props) {
   const [title, setTitle] = useState("")
   const [educlevel, setEducLevel] = useState()
   const [gradelevel, setGradeLevel] = useState()
   const [section, setSection] = useState()
   const [sectionList, setSectionList] = useState([])
   const [contentdata, setContentData] = useState("")
   const [disablesection, setDisableSection] = useState(false)
   const [disablelevel, setDisableLevel] = useState(false)
   const [data, setData] = useState()
   const [fileList, setFileList] = useState([]); // For Component Display
   const [deletedfileList, setDeletedFileList] = useState([]); // Deleted files
   const [origFileList, setOrigFileList] = useState([]); // For Lookup
   const [fileNewList, setFileNewList] = useState([]); // For Editing final list of file
   const [fileUpdateNewfiles, setFileUpdateNewfiles] = useState([]); // For Editing new files

   const [done, setDone] = useState(false)
   const [effectivityDate, setEffectivityDate] = useState();
   const [spinning, setSpinning] = useState(false)
   // const [data,setData] = useState(false)
   // const [tables,setTables] = useState({
   //     subjects: [],
   //     acadPrograms: [],
   //     acadProgramLevels: [],
   //     terms: [],
   //     classSections: []
   //   });
   const [form] = Form.useForm();
   const dispatch = useDispatch();
   const lookupSelector = useSelector(state => state.lookup);
   const noticeSelector = useSelector(state => state.noticeboard);

   const { RangePicker } = DatePicker;
   const dateFormat2 = 'MMM D, YYYY h:mm a';
   const dateFormat = 'YYYY-MM-DD HH:mm';
   const customFormat = value => `${value.format(dateFormat)}`;
   const { TextArea } = Input;
   // const start_date = moment(noticeSelector.start_date, dateFormat);
   // const end_date  = moment(noticeSelector.end_date, dateFormat);

   useEffect(() => {
      let item = noticeSelector;
      var files = item.filelist.split(",")
      setOrigFileList(files) // preserve the original list
      setFileNewList(files) // for edited new list of files
      var filearray = []
      files.forEach((file, index) => {
         var item =    {
                        uid: index,
                        name: file,
                        status: 'done',
                      }
         filearray.push(item)             
      });
      setFileList(filearray)
      setData(item);
      distribute();
      let effdate = [moment(noticeSelector.start_date, dateFormat), moment(noticeSelector.end_date, dateFormat)];
      setEffectivityDate(effdate);
   }, []);

   // const FormatDate = () => {
   //    if (effectivityDate && effectivityDate.length > 0) {
   //       const d1 = effectivityDate[0];
   //       const d2 = effectivityDate[1];
   //       const arr = [moment(d1, dateFormat), moment(d2, dateFormat)];
   //       return arr;
   //    } else {
   //       console.log('no value');
   //       return  [];
   //    }
   // }
   const propsUpload = {
    onRemove: file => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);

      // Delete new list
      const nindex = fileNewList.indexOf(file.name);
      if (nindex >= 0)
      {
         const newFileNewList = fileNewList.slice();
         newFileNewList.splice(nindex, 1);
         setFileNewList(newFileNewList);
      }

      // Add to deleted file
      var origIdx = origFileList.indexOf(file.name) // Should be on the original file list
      if (origIdx >= 0)
      {
         var idx = deletedfileList.indexOf(file.name)
         var itemfilelist = deletedfileList.slice()
         if (idx >= 0)
         {
            itemfilelist.splice(idx, 1); 
            itemfilelist.push(file.name)
            setDeletedFileList(itemfilelist)
         // setDeletedFileList(itemfilelist)
         }
         else
         {      
            setDeletedFileList([...deletedfileList,file.name])
         }
      }


    },
    beforeUpload: file => {
            const isPNG = file.type === 'image/png';
            const isJPG = file.type === 'image/jpeg';
            const isBMP = file.type === 'image/bmp';
            const isMovie = file.type === 'video/mp4';
            // const isDOC = file.type === 'application/msword' || file.type === 'application/vnd.ms-word';
            // const isDOCX = file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            // const isXLS = file.type === 'application/msexcel' || file.type === 'application/vnd.ms-excel';
            // const isXLSX = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            // const isPPT = file.type === 'application/vnd.ms-powerpoint';
            // const isPPTX = file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
            // const isPPSX = file.type === 'application/vnd.openxmlformats-officedocument.presentationml.slideshow';
            const isPDF = file.type === 'application/pdf';

            // const fileValid = isPNG || isJPG || isBMP || isDOC || isDOCX || isXLS || isXLSX || isPPT || isPPTX || isPDF || isPPSX;
            const fileValid = isPNG || isJPG || isBMP || isPDF || isMovie;
            if (fileValid) {
               const isLt100M = file.size / 1024 / 1024 <= 10;

               if (isLt100M) {
                  setFileList([...fileList, file]);
                  setFileNewList([...fileNewList, file.name]);
                  setFileUpdateNewfiles([...fileUpdateNewfiles, file])
               } else {
                  Modal.error({
                     title: 'Schedule',
                     content: 'Maximum allowed file size is 10 MB',
                     centered: true
                  });
               }
            } else {
               Modal.error({
                  title: 'Schedule',
                  content: 'You are not allowed to upload that file type',
                  centered: true
               });
            }           
      return false;
    },
    fileList,
    multiple: true, // Enable multiple file selection
  };   

   const handleChangeDate = (date, dateString) => {
      const d = dateString[0];//'Jan 21, 2022, 7:07:00 am';
      const d2 = dateString[1];//'Jan 21, 2022, 7:07:00 am';
      const dvalue = d + ' - ' + d2;
      setEffectivityDate(dateString);
   }

   const handleFormValuesChange = (changedValues) => {
      const formFieldName = Object.keys(changedValues)[0];
      if (formFieldName === "educationallevel") {
         setEducLevel(changedValues[formFieldName]);
         form.setFieldsValue({ level: undefined });
         form.setFieldsValue({ sections: undefined });
         setSectionList([])
      } else if (formFieldName === "level") {
         setGradeLevel(changedValues[formFieldName]);
         form.setFieldsValue({ sections: undefined });
         setSectionList([])
      }
   };

   const distribute = () => {
      setTitle(noticeSelector.title)
      setContentData(noticeSelector.content)
      // setSectionList(lookupSelector.classSections)
      setGradeLevel(noticeSelector.gradelevellist)
      if (noticeSelector.acadlevellist === 'ALL' || noticeSelector.acadlevellist === '99') {
         setDisableSection(true)
         setDisableLevel(true)
         setSectionList([])
      } else {
         setDisableSection(false)
         setDisableLevel(false)
      }

      if (noticeSelector.gradelevellist === '99') {
         setDisableSection(true)
         setSectionList([])
      } else {
         setDisableSection(false)
         let tempsections = lookupSelector.classSections;
         let filtered = tempsections.filter(item => item.code === `${noticeSelector.gradelevellist}`);
         setSectionList(filtered)
      }

      setEducLevel(noticeSelector.acadlevellist)
   }

   const handleChangeTitle = (e) => {
      setTitle(e)
      var params = { key: `title`, value: e }
      dispatch(update_notice_data(params))
   }


   const handleChangeEducLevel = (e) => {
      setEducLevel(e)
      var params = { key: `acadlevellist`, value: e }
      dispatch(update_notice_data(params))
      if (e === '99') {
         setDisableLevel(true)
         setDisableSection(true)
      } else {
         setDisableLevel(false)
         setDisableSection(false)
      }
   }

   const handleChangeLevel = (e) => {
      let tempsections = lookupSelector.classSections;
      let filtered = tempsections.filter(item => item.code === `${e}`);
      setGradeLevel(e)
      setSectionList(filtered)
      var params = { key: `gradelevellist`, value: e }
      dispatch(update_notice_data(params))
      if (e === 99) {
         setDisableSection(true)
      } else {
         setDisableSection(false)
      }
   }

   const handleChangeSection = (e) => {
      setSection(e);
      var params = { key: `sectionlist`, value: e }
      dispatch(update_notice_data(params))
   }

   // const handleChangeEditor = (content,editor) => {
   //     setContent(content);
   //     var params = {key: `content` ,value : content}
   //     dispatch(update_notice_data(params))
   // }

   const onFinish = (values) => {
      console.log('Success:', values);
      setSpinning(true)
      let user = Utils.getCurrentUserInfo(Enums.UserInfo.id)
      var notice_id = noticeSelector.id;
      let gradeLevel = noticeSelector.gradelevellist;
      let sections = noticeSelector.sectionlist;
      let educLevel = noticeSelector.educlevel;
      let effective_start_date = effectivityDate[0];
      let effective_end_date = effectivityDate[1];

      if (typeof educLevel === 'undefined') {
         educLevel = "";
         console.log('is undefined');
      }

      if (typeof gradeLevel === 'undefined') {
         gradeLevel = "";
         console.log('is undefined');
      }
      if (typeof sections === 'undefined') {
         sections = "";
         console.log('is undefined');
      }
      
      var FilterfileNewList = fileNewList.filter(item => item);
      let notice_default = {
         id: notice_id,
         title: noticeSelector.title,
         content: contentdata,
         active: 0,
         issection: 0,
         sectionlist: sections,
         isgradelevel: 0,
         gradelevellist: gradeLevel,
         isacad: 0,
         acadlevellist: noticeSelector.acadlevellist,
         staffid: user,
         start_date: moment(effective_start_date).format("YYYY-MM-DD HH:mm:ss"),
         end_date: moment(effective_end_date).format("YYYY-MM-DD HH:mm:ss"),
         deletedfiles : deletedfileList,
         files : fileUpdateNewfiles,
         filelist : FilterfileNewList.join(",")
      }
      NoticeService.saveNotice(notice_default).then(response => {
         console.log(response)
         if (response.data != "Nok") {
            setSpinning(false)
            Modal.success({
               title: 'Create Notice Board',
               content: 'Notice Record was created.',
               centered: true
            })

            setDone(true);
         }
         else
         {
            setSpinning(false)
            Modal.error({
               title: 'Create Notice Board',
               content: 'Notice Record creation failed.',
               centered: true
            });            
         }
      }, (error) => {
         setSpinning(false)
         console.log(error.message);
         Modal.error({
            title: 'Update Notice Board',
            content: 'Notice Record update failed.',
            centered: true
         });
         setDone(false)
      });

   };

   return (
      <>
         {done && <Navigate to={'/notice'} replace state={{}} />}
         <div className="dashboard-area-all noticeboard-page">
            <div className="dashboard-item noticeboard-shell">
               <div className="noticeboard-breadcrumb">
                  <ResponsiveBreadcrumb
                     items={[
                        { key: 'home', node: <Link to="/home">Home</Link> },
                        { key: 'notice-board', node: <Link to="/notice">Notice Board</Link> },
                        { key: 'edit', node: 'Edit' },
                     ]}
                  />
               </div>
               <section className="noticeboard-overview">
                  <div>
                     <span className="noticeboard-kicker">Announcements</span>
                     <h1>Edit Notice</h1>
                     <p>Update the notice details, audience, effective dates, content, and attachments.</p>
                  </div>
               </section>
               <Spin spinning={spinning} fullscreen tip="Saving...">
                  <section className="noticeboard-panel">
                     <div className="noticeboard-panel-header">
                        <div>
                           <span className="noticeboard-kicker">Details</span>
                           <h2>Notice Information</h2>
                        </div>
                     </div>
                     <Form
                        form={form}
                        className='noticeboard-form'
                        colon={false} onFinish={onFinish}
                        // onFinishFailed={onFinishFailed} 
                        onValuesChange={handleFormValuesChange}
                        autoComplete="off"
                        layout="vertical"
                     >
                        <div className="noticeboard-form-grid">
                              <Form.Item label="Title" name="title"
                                 // rules={[
                                 //     { 
                                 //     required: true,
                                 //     message: 'Title should not be blank!'
                                 //     },
                                 // ]} 
                                 initialValue={noticeSelector.title}
                              >
                                 <Input
                                    size="small"
                                    placeholder="Title"
                                    value={noticeSelector.title}
                                    style={{ color: '#000000' }}
                                    onChange={(event) => handleChangeTitle(event.target.value)}
                                 />

                              </Form.Item>
                              <Form.Item label="Educational Level" name="educationallevel"
                                 // rules={[
                                 //     { 
                                 //     required: true,
                                 //     message: 'Please choose an Educational Level!'
                                 //     },
                                 //     ]}
                                 initialValue={noticeSelector.acadlevellist}
                              >
                                 <Select defaultValue={''} onChange={handleChangeEducLevel}>
                                    <Select.Option value={'99'}>{'All'}</Select.Option>
                                    {lookupSelector.acadPrograms.map((level) => (
                                       <Select.Option value={level.programCode}>{level.description}</Select.Option>
                                    ))}
                                 </Select>
                              </Form.Item>
                              <Form.Item label="Grade Level" name="level"
                                 rules={[
                                 { 
                                 required: educlevel == "99" ? false : true,
                                 message: 'Please choose a Level!'
                                 },
                                 ]} 
                                 initialValue={noticeSelector.gradelevellist === '' ? '99' : noticeSelector.gradelevellist}
                              >
                                 <Select
                                    style={{ width: '100%' }}
                                    value={gradelevel}
                                    onChange={(e) => {
                                       handleChangeLevel(e);
                                    }}
                                    disabled={disablelevel}>
                                    <Select.Option value={'99'}>{'All'}</Select.Option>
                                    {
                                       lookupSelector.acadProgramLevels.filter(item => item.programCode === `${educlevel}`).map((filtered) => (
                                          <Select.Option value={filtered.value}>{filtered.label}</Select.Option>
                                       ))}
                                 </Select>
                              </Form.Item>
                              <Form.Item label="Sections" name="sections"
                                 // rules={[
                                 // { 
                                 // required: true,
                                 // message: 'Please choose a Section!'
                                 // },
                                 // ]}
                                 initialValue={noticeSelector.gradelevellist === '99' ? '' : noticeSelector.sectionlist}
                              >
                                 <Select
                                    placeholder="Please select"
                                    mode="multiple"
                                    allowClear
                                    showArrow
                                    style={{ width: '100%' }}
                                    // options={lookupSelector.classSections}
                                    options={noticeSelector.gradelevellist === '99' ? '' : sectionList}
                                    onChange={handleChangeSection}
                                    disabled={disablesection}
                                 />

                              </Form.Item>
                              <Form.Item className="noticeboard-form-full" label="Effectivity Date" name="effectivedate">
                                 <RangePicker
                                    showTime={{ format: 'hh:mm A', use12Hours: true }}
                                    format={dateFormat2}
                                    // defaultValue={ FormatDate } 
                                    onCalendarChange={handleChangeDate}
                                    defaultValue={[moment(noticeSelector.start_date, dateFormat), moment(noticeSelector.end_date, dateFormat)]}
                                    style={{ width: '100%' }}
                                 />
                              </Form.Item>

                              <Form.Item 
                                 className="noticeboard-form-full" 
                                 label="Content" 
                                 name="content"
                                 initialValue={noticeSelector.content}
                              >
                                 <TextArea 
                                    rows={7} 
                                    onChange={(e) => setContentData(e.target.value)} 
                                 />
                              </Form.Item>
                              {/* <Wysiwyg 
                                 changeContentCallback={(e) => setContentData(e)} 
                                 content={noticeSelector.content} 
                                 height={400}
                                 contentHeight={360}
                              /> */}
                              <Form.Item className="noticeboard-form-full" label="Add file(s) to the message" name="fileupload">  
                                 <div className="noticeboard-upload-wrap">   
                                 <Upload {...propsUpload}>
                                    <Button icon={<UploadOutlined />}>Select File</Button>
                                 </Upload>  
                                 </div>
                               </Form.Item>    
                        </div>
                        <div className="noticeboard-form-actions">
                           <Button className="noticeboard-save-button" type="primary" htmlType="submit" shape='round'>
                              Save Notice
                           </Button>
                        </div>
                     </Form>
                  </section>
                  </Spin>
            </div>
         </div>
         {/* <div className="notice-area">
            <div className="notice-item">
               <SideCalendar />
               <NoticeBoard />
            </div>
         </div> */}
      </>
   );
}

export default EditNotice;
